export default __webpack_public_path__ + "static/media/bg_in_range.451ea366.svg";